import {
    GET_MESSAGE_ITEM_BODY,
    GET_RICH_STICKY_NOTE_TEXT,
    TIME_ZONE,
    ATTENDEES,
    USE_DEBUG_MODE,
} from '../constants';
import { logSimpleSonoraDatapoint } from '../dataLogger/logSonoraDatapoint';
import { trace } from 'owa-trace';
import getDataProviderToSuggestionsDictionary from './getDataProviderToSuggestionsDictionary';
import {
    isSonoraPluginRichStickyNoteSuggestionsEnabled,
    isSonoraPluginRichStickyNoteViaGetItemSuggestionsEnabled,
} from './stickyNotes/isSonoraPluginStickyNoteSuggestionsEnabled';
import isSonoraDebugModeEnabled from './shared/isSonoraDebugModeEnabled';
import {
    SonoraDataProviderConfig,
    SonoraEntityType,
    UserDataServiceSuggestions,
} from 'owa-editor-sonora-types';
import { getUserTimeZone } from 'owa-session-store';
import {
    DataProviderFilter,
    DataProviderFilterType,
    getSuggestionsFromUserDataService,
    UserDataServiceRequestType,
} from 'owa-userdataservice';
import { DataProviderType } from '@augloop-types/honeybee';

export default async function fetchUserDataServiceSuggestions(
    queryString: string,
    dataProviders: DataProviderType[],
    config: SonoraDataProviderConfig,
    callInitOps: boolean,
    requiredAttendees?: string
): Promise<UserDataServiceSuggestions> {
    if (!dataProviders?.length) {
        return {};
    }

    const dataProviderFilter = <DataProviderFilter>{
        filterType: DataProviderFilterType.AllowedDataSources,
        providerTypes: dataProviders,
    };

    /**
     * Use customheaders to determine how to retrieve the rich note content.
     * If both headers are specified, the GetMessageItemBody header will take
     * precedence over the other.
     */
    const customHeaders = {};
    if (isSonoraDebugModeEnabled()) {
        customHeaders[USE_DEBUG_MODE] = 'true';
    }
    if (isSonoraPluginRichStickyNoteViaGetItemSuggestionsEnabled()) {
        customHeaders[GET_MESSAGE_ITEM_BODY] = 'true';
    } else if (isSonoraPluginRichStickyNoteSuggestionsEnabled()) {
        customHeaders[GET_RICH_STICKY_NOTE_TEXT] = 'true';
    }
    if (config.dataProviderEnabledStatus[SonoraEntityType.MeetingTimes]) {
        customHeaders[TIME_ZONE] = getUserTimeZone() ?? '';
        if (requiredAttendees) {
            customHeaders[ATTENDEES] = requiredAttendees;
        }
    }

    let results: UserDataServiceSuggestions = {};

    await getSuggestionsFromUserDataService(
        queryString,
        UserDataServiceRequestType.UserInitiated,
        callInitOps,
        dataProviderFilter,
        customHeaders
    )
        .then(suggestions => {
            results = getDataProviderToSuggestionsDictionary(dataProviders, config, suggestions);
        })
        .catch(error => {
            trace.warn(error);
            logSimpleSonoraDatapoint('SonoraUserDataServiceFailure', {
                errorMessage: error.message,
            });
        });
    return Promise.resolve(results);
}
